import React from "react";

import "./pagination.css";

/**
 *  Renders a pagination component
 * @param {number} page Page number
 * @param {number} limit  Maximum record per request
 * @param {number} totalDocs  Total record on server
 * @param {number} totalPage  Total page
 * @param {number} prevPage  Previous page
 * @param {number} nextPage  Next page
 * @param {number} length  length of docs
 * @param {function} onPageClicked  Function to call on page number selected
 */
const Pagination = ({
	limit = 25,
	page = 1,
	totalDocs = 0,
	totalPages = 0,
	nextPage = null,
	prevPage = null,
	length = 0,
	onPageClicked
}) => {
	const maxPage = 6;

	// Get page number
	const getPageNumber = () => (page - 1) * limit + 1;

	// get buttons
	const makeArrayFromDocs = () => {
		let newList = [];
		for (let i = 0; i < totalPages; i++) {
			newList.push(i);
		}

		return newList;
	};
	if (totalDocs)
		return (
			<div className="row fade-in">
				<div className="col-sm-12 col-md-4">
					<div
						className="page-summary"
						id="example1_info"
						role="status"
						aria-live="polite"
					>
						Showing <strong>{getPageNumber()}</strong> -{" "}
						<strong>{getPageNumber() + length - 1}</strong> of{" "}
						<strong>{totalDocs}</strong> entries
					</div>
				</div>
				<div className="col-sm-12 col-md-8 text-right">
					<div
						className="dataTables_paginate paging_simple_numbers"
						id="example1_paginate"
					>
						<ul className="pagination">
							<li id="example1_previous">
								<button
									onClick={() => {
										if (prevPage) {
											onPageClicked(prevPage);
										}
										return;
									}}
									tabIndex="0"
									disabled={prevPage === null}
									className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 btn-circle"
								>
									<i className="material-icons">
										keyboard_arrow_left
									</i>{" "}
									Prev
								</button>
							</li>
							{makeArrayFromDocs()
								.slice(0, 10)
								.map(item => (
									<li key={item}>
										<button
											onClick={() => {
												if (item + 1 !== page) {
													onPageClicked(item + 1);
												}
												return;
											}}
											tabIndex="0"
											className={`mdl-button mdl-button--icon margin-right-10 page-item ${
												page === item + 1
													? "btn-success"
													: "btn-default"
											}`}
										>
											{item + 1}
										</button>
									</li>
								))}
							{makeArrayFromDocs().length > maxPage && (
								<li>
									<button
										tabIndex="0"
										className={`mdl-button mdl-button--icon margin-right-10 page-item ${
											page > maxPage
												? "btn-success"
												: "btn-default"
										}`}
										s
									>
										<i className="material-icons">
											more_horiz
										</i>
									</button>
								</li>
							)}
							<li id="example1_next">
								<button
									disabled={nextPage === null}
									tabIndex="0"
									className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle"
									onClick={() => {
										if (nextPage) {
											onPageClicked(nextPage);
										}
										return;
									}}
								>
									Next{" "}
									<i className="material-icons">
										keyboard_arrow_right
									</i>
								</button>
							</li>
						</ul>
					</div>
				</div>
			</div>
		);
	else return null;
};

export default Pagination;
